import React from "react";
import { Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const FormikLabel = ({
  text = "Label",
  required = false,
  icon = null,
  onClick,
}) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      mb={0.5}
      onClick={onClick}
      sx={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
        {text}
        {required && (
          <span style={{ color: theme.palette.error.main }}> *</span>
        )}
      </Typography>
      {icon}
    </Box>
  );
};

export default FormikLabel;
